<template>
  <div class="d-block flex-wrap py-3 text-center">
    <b-button
      v-if="secondButton"
      :variant="secondButtonVariant"
      @click="onSecondSubmit"
      :disabled="isLoading || isLoadingSecondButton || secondButtonDisabled"
      pill
      size="lg"
      class="mx-2 mb-3 text-uppercase"
      style="min-width: 10rem"
    >
      <AppSpinner class="d-inline-block align-middle" v-if="isLoadingSecondButton"/>
      {{$t(secondButtonText)}}
    </b-button>

    <b-button
      v-if="firstButton"
      :variant="variant"
      @click="onSubmit"
      :disabled="isLoading || isLoadingSecondButton || isDisabled"
      pill
      size="lg"
      class="mb-3 text-uppercase"
      :class="[{'d-block': !secondButtonText}, secondButtonText ? 'mx-2' : 'mx-auto']"
      style="min-width: 10rem"
    >
      <AppSpinner class="d-inline-block align-middle" v-if="isLoading"/>
      {{$t(submitText)}}
    </b-button>
    <a
      v-if="!noCancel"
      @click="onCancel"
      type="button"
      :class="[(isLoading || isLoadingSecondButton) ? 'd-none': '',
      !(isLoading || isLoadingSecondButton) ? 'd-block': '', 'text-center text-'+variant ]"
    >
      {{$t(cancelText)}}
    </a>
  </div>
</template>

<script>
  import {pages} from "../../../shared/constants/pages/index"
  import AppSpinner from "./AppSpinner";
  export default {
    name: "AppConfirmButtons",
    components: {AppSpinner},
    props: {
      isLoading: false,
      isLoadingSecondButton: {
        type: Boolean,
        default: false
      },
      isDisabled: false,
      submitText: {
        type: String,
        default: pages.button.save
      },
      cancelText: {
        type: String,
        default: pages.button.cancel
      },
      variant: {
        type: String,
        default: 'secondary'
      },
      noCancel: {
        type: Boolean,
        default: false
      },
      firstButton: {
        type: Boolean,
        default: true
      },
      secondButton: {
        type: Boolean,
        default: false
      },
      secondButtonText: {
        type: String,
        default: null
      },
      secondButtonVariant: {
        type: String,
        default: 'outline-secondary'
      },
      secondButtonDisabled: {
        type: Boolean,
        default: false
      },
    },
    methods: {
      onSubmit() {
        this.$emit("onSubmit");
      },
      onSecondSubmit() {
        this.$emit("onSecondSubmit");
      },
      onCancel() {
        this.$emit("onCancel");
      },
    }
  }
</script>

<style scoped>

</style>
